(function ($) {
    $(document).ready(function () { 
        if($('.page-template-template-tco .tco_brands-slider.noslider').length >0
            && ($('.page-template-template-tco .tco_brands-slider input:checked').length==0)){
                $('.page-template-template-tco .tco_brands-slider > div:first-of-type input').attr('checked',true);
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'choose sub model',
                    'Label':$('.page-template-template-tco .tco_brands-slider > div:first-of-type input').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer)
                $('.page-template-template-tco .tco_brands-slider input').click(function(){
                    dataLayer.push({
                        'Category':'TCO calculator',
                        'Action':'choose sub model',
                        'Label':$(this).val(),
                        'event':'auto_event'
                    });
                    console.log('datalayer',dataLayer)
                })
            }

        $('.page-template-template-tco .tco_brands-slider').on("init", function(slick) {
            setTimeout(function(){
                $('.page-template-template-tco .tco_brands-slider .slick-slide').attr('tabindex','-1').click(function(e){
                    e.preventDefault();
                    //$(this).find('input').prop("checked", true);
                    
                    if(parseInt($(this).attr('data-slick-index')) > parseInt($('.page-template-template-tco .tco_brands-slider .slick-active.slick-center').attr('data-slick-index'))){
                        $('.page-template-template-tco .tco_brands-slider .slick-next').click();
                    }
                    else if(parseInt($(this).attr('data-slick-index')) < parseInt($('.page-template-template-tco .tco_brands-slider .slick-active.slick-center').attr('data-slick-index'))){
                        $('.page-template-template-tco .tco_brands-slider .slick-prev').click();
                    }
                });
                //$('.page-template-template-tco .tco_brands-slider .slick-active').attr('tabindex','0');
                $('.page-template-template-tco .tco_brands-slider .slick-slide input').each(function(){
                    if(!$(this).attr('id')){
                        $(this).attr('id','tco-model-'+$(this).parent().attr('data-slick-index'))
                        $(this).parent().find('label').attr('for',$(this).attr('id'))
                    }
                })
                $('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').prop("checked", true);
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'choose sub model',
                    'Label':$('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer)
                if($('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').attr('data-dizel') == '1'){
                    $('.page-template-template-tco .engine-block').show();
                }
                else{
                    $('.page-template-template-tco .engine-block input[name=tcu_type]').attr('checked',false);
                }
                /*$('.page-template-template-tco .tco_brands-slider .slick-slide').attr('tabindex','-1').on('keydown', function (e) {
                    if ((e.which === 9 && !e.shiftKey)) {
                      e.preventDefault();
                    }
                });*/
            },0);
        });
        if($('.page-template-template-tco .tco_brands-slider .tco_model_name').length>2){
        $('.page-template-template-tco .tco_brands-slider').slick({
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 3,
            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="הקודם"></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="הבא"></button>',
            rtl: true,
            responsive: [
              /*{
                breakpoint: 768,
                settings: {
                  arrows: true,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: true,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 3
                }
              }*/
            ]
        });
    }
        $('.page-template-template-tco .tco_brands-slider').on('afterChange', function(event, slick, currentSlide){
            setTimeout(function(){
                $('.page-template-template-tco .tco_brands-slider .slick-slide').attr('tabindex','-1');
                //$('.page-template-template-tco .tco_brands-slider .slick-active').attr('tabindex','0');
                $('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').prop("checked", true).focus();
                console.log('vlad',$('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').val())
                dataLayer.push({
                    'Category':'TCO calculator',
                    'Action':'choose sub model',
                    'Label':$('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').val(),
                    'event':'auto_event'
                });
                console.log('datalayer',dataLayer)
                if($('.page-template-template-tco .tco_brands-slider .slick-active.slick-center input').attr('data-dizel') == '1'){
                    $(".page-template-template-tco .engine-block input[name=tcu_type]:first").click();
                    $('.page-template-template-tco .engine-block').show();
                }
                else{
                    $('.page-template-template-tco .engine-block').hide();
                    $('.page-template-template-tco .engine-block input[name=tcu_type]').attr('checked',false);
                }
            },1);
        });
    }); 
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/slider.js